import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import ApiCall from "../services/apiCall";
import { ToastContainer, toast } from "react-toastify";
import LoadingSpinner from "../components/LoadingSpinner";

const editProfile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const { firstName, lastName, phoneNumber } = location.state || {};
  const [name, setName] = useState({
    firstName: firstName || "",
    lastName: lastName || "",
  });
  const [number, setNumber] = useState(phoneNumber || "");
  const [isLoading, setLoading] = useState(false);

  const handleEditProfile = async () => {
    const data = {
      firstName: name?.firstName,
      lastName: name?.lastName,
      phoneNumber: number,
    };

    // Custom validation logic
    const isValid = validateData(data);
    if (!isValid) {
      return;
    }

    try {
      setLoading(true);
      const res = await ApiCall("api/user", "POST", JSON.stringify(data));
      if (res.ok) {
        navigate("/profile");
      }
      if (res?.message || res?.data?.message) {
        toast.success(res?.message || res?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const validateData = (data) => {
    if (!data.firstName || data.firstName.trim() === "") {
      toast.error("First name is required");
      return false;
    }
    if (!data.lastName || data.lastName.trim() === "") {
      toast.error("Last name is required");
      return false;
    }
    if (!data.phoneNumber || data.phoneNumber.trim() === "") {
      toast.error("Phone number is required");
      return false;
    }
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(data.phoneNumber)) {
      toast.error("Invalid phone number");
      return false;
    }
    return true;
  };

  return (
    <Layout>
      {/* SignUp Section */}
      <section
        className="login-section section-gap wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="midd-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-sec">
                <h2 className="title-30 wow fadeInUp" data-wow-delay="0.2s">
                  Edit Profile
                </h2>
              </div>
              <div className="form-sec">
                <form className="wow fadeInUp" data-wow-delay="0.2s">
                  <div className="input-sec">
                    <input
                      type="text"
                      name=""
                      value={firstName}
                      placeholder="First Name"
                      className="form-control"
                      onChange={(e) =>
                        setName({ ...name, firstName: e.target.value })
                      }
                    />
                  </div>
                  <div className="input-sec mt-4">
                    <input
                      type="text"
                      name=""
                      value={lastName}
                      placeholder="Last Name"
                      className="form-control"
                      onChange={(e) =>
                        setName({ ...name, lastName: e.target.value })
                      }
                    />
                  </div>
                  <div className="input-sec mt-4">
                    <input
                      type="number"
                      name=""
                      value={number}
                      placeholder="Phone Number"
                      className="form-control"
                      onChange={(e) => setNumber(e.target.value)}
                    />
                  </div>
                  <div className="btn-sec">
                    {isLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <button
                        type="button"
                        className="btn"
                        onClick={handleEditProfile}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* SignUp Section End */}

      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
      <ToastContainer />
    </Layout>
  );
};

export default editProfile;
